import React from "react";
import { Image } from "./common/NextAdapters";
import { Icon } from "@iconify/react";
import { cn } from "../lib/utils";

// Each avatar is a glyph on a slice of the brand ramp, so profiles read as
// part of Kast rather than stock pictures, and need no artwork from the API.
export const AVATARS = [
  { id: "smiley", icon: "ph:smiley-bold", from: "var(--ember)", to: "var(--flame)" },
  { id: "planet", icon: "ph:planet-bold", from: "var(--violet)", to: "var(--electric)" },
  { id: "rocket", icon: "ph:rocket-launch-bold", from: "var(--flame)", to: "var(--magenta)" },
  { id: "cat", icon: "ph:cat-bold", from: "var(--magenta)", to: "var(--violet)" },
  { id: "dog", icon: "ph:dog-bold", from: "var(--electric)", to: "var(--magenta)" },
  { id: "ghost", icon: "ph:ghost-bold", from: "var(--violet)", to: "var(--magenta)" },
  { id: "alien", icon: "ph:alien-bold", from: "var(--electric)", to: "var(--violet)" },
  { id: "butterfly", icon: "ph:butterfly-bold", from: "var(--ember)", to: "var(--magenta)" },
  { id: "crown", icon: "ph:crown-simple-bold", from: "var(--ember)", to: "var(--violet)" },
  { id: "controller", icon: "ph:game-controller-bold", from: "var(--flame)", to: "var(--electric)" },
];

const AVATAR_IDS = new Set(AVATARS.map((avatar) => avatar.id));

export function avatarFor(id) {
  return AVATARS.find((avatar) => avatar.id === id) ?? AVATARS[0];
}

// A profile's AvatarUrl is either one of the preset icon ids above, or the path to a
// custom photo uploaded via profileApi.uploadAvatar — this tells the two apart.
export function isPresetAvatarId(value) {
  return AVATAR_IDS.has(value);
}

export function ProfileAvatar({ avatarId, imageUrl, className, iconClassName }) {
  const resolvedImageUrl = imageUrl || (avatarId && !isPresetAvatarId(avatarId) ? avatarId : null);

  if (resolvedImageUrl) {
    return (
      <span
        aria-hidden
        className={cn("relative flex shrink-0 overflow-hidden rounded-md bg-card", className)}
      >
        <Image src={resolvedImageUrl} alt="" fill sizes="160px" unoptimized className="object-cover" />
      </span>
    );
  }

  const avatar = avatarFor(avatarId);

  return (
    <span
      aria-hidden
      className={cn(
        "flex shrink-0 items-center justify-center overflow-hidden rounded-md text-white",
        className
      )}
      style={{ backgroundImage: `linear-gradient(135deg, ${avatar.from}, ${avatar.to})` }}
    >
      <Icon icon={avatar.icon} className={cn("size-1/2", iconClassName)} />
    </span>
  );
}
